export enum PurchaseRequestStatus {
  INITIAL,
  CABINS_COMPLETED,
  PASSENGER_COMPLETED,
  TOUR_SUMMARY,
  DATA_PASSENGER_COMPLETED,
  PAYMENT_COMPLETED ,
  BOOCKING_CONFIRMATION_SENT
}
